module.exports = __webpack_public_path__ + "img/x3.44706428.jpg";